<app-project-config (onClose)="Hide()" #config [project]="project" [updateHandler]="updateHandler"></app-project-config>
